// 判断是否为移动端
import { Message } from "element-ui";
const baseType = ["android", "iphone", "ipod", "blackberry", "windows phone"];
export function isMobileDevice(isOnlyMobile = false) {
  const userAgent = navigator.userAgent.toLowerCase();
  const mobileKeywords = isOnlyMobile ? baseType : [...baseType, "ipad"];
  for (const keyword of mobileKeywords) {
    if (userAgent.includes(keyword)) {
      return true;
    }
  }
  const screenWidth = window.screen.width;
  if (screenWidth < 640) {
    return true;
  }
  return !isOnlyMobile ? "ontouchstart" in window : false;
}
let timeOut = null;
export default () => {
  if (!isMobileDevice()) return undefined;
  const changeOrientation = () => {
    if (timeOut) clearTimeout(timeOut);
    timeOut = setTimeout(() => {
      if (window.matchMedia("(orientation: portrait)").matches) {
        Message.warn("请横屏全屏操作，获得更好的体验！");
      } else {
        window.document.body.style.transform = "rotate(0deg)";
      }
    }, 200);
  };
  window.addEventListener("orientationchange", changeOrientation);
  // 页面加载时应用横屏样式
  changeOrientation();
  return () => {
    window.removeEventListener("orientationchange", changeOrientation);
  };
};
